import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css' // Import Bootstrap CSS
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store/store';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      {/* <BrowserRouter> */}
      <App />
      {/* </BrowserRouter> */}
    </React.StrictMode>
  </Provider>
);
